export const USER_NAME = "Jose";
export const ASSISTANT_NAME = "GORDO";
export const SPEECH_LANG = "es-ES";

// Frases de la UI que GORDO dice sin pasar por el LLM.
export const WAKE_ACK = "Dime.";
// Se dice cuando detecta wake word / PTT pero no captura nada: varias
// variantes para que no suene siempre a grabación repetida.
export const IDLE_FAREWELLS = [
  "Aquí estaré cuando me necesites, haciendo como que trabajo.",
  "Nada, pues aquí sigo, de brazos cruzados y cobrando en imaginación.",
  "Silencio total. Si era una emboscada, bastante decepcionante.",
  "Vale, tú a lo tuyo. Yo aquí, evitando responsabilidades como un profesional.",
  "Como veas. Yo no tengo prisa por currar; el mundo tampoco parece tenerla conmigo.",
];
export const FOLLOWUP_FAREWELLS = [
  "Como no dices nada, me retiro con dignidad. Bueno, con la poca que me queda.",
  "Entiendo que era todo. Me quedo aquí, en modo estatua con ansiedad.",
  "Voy cerrando el chiringuito. Si me necesitas, ya sabes: invócame.",
  "Silencio administrativo. Me voy antes de empezar a cobrar por esperar.",
  "Parece que hemos terminado. Una conversación breve, casi sospechosamente eficiente.",
];
export const NUCLEUS_ERROR_FAREWELL =
  "Perdona, ahora mismo no puedo atenderte. Tengo un fallo en el núcleo.";

// Patrones locales (no LLM) para acciones de UI. Se aplican después del wake
// word al comando que diga el usuario.
export const CHAT_OPEN_PATTERNS: RegExp[] = [
  /\b(abre|abrir|muestra|mostrar|enseña|enseñar)\s+(el\s+)?chat\b/i,
];
export const CHAT_CLOSE_PATTERNS: RegExp[] = [
  /\b(cierra|cerrar|esconde|esconder|oculta|ocultar)\s+(el\s+)?chat\b/i,
];

// LLM (Gemini, free tier). Los alias `-latest` siguen vivos en el
// free tier aunque las versiones pinneadas (`gemini-2.0-flash`,
// `gemini-2.5-flash`, `gemini-2.5-flash-lite`) devuelven 404 hoy.
// `gemini-flash-lite-latest` apunta a la versión Lite, con un pool de
// cuota distinto (no compartido con `gemini-flash-latest`).
export const GEMINI_BASE_URL = "https://generativelanguage.googleapis.com/v1beta";
export const GEMINI_MODEL = "gemini-flash-lite-latest";

// Tavily web search (free tier, 1000 búsquedas/mes)
export const TAVILY_API_URL = "https://api.tavily.com/search";

// Edge TTS (fallback)
export const TTS_VOICE = "es-ES-AlvaroNeural";
export const TTS_OUTPUT_FORMAT = "audio-24khz-48kbitrate-mono-mp3";

// ElevenLabs (primary)
export const ELEVENLABS_VOICE_ID = "qgbcpbuIfdXf7yaRryAD";
export const ELEVENLABS_MODEL_ID = "eleven_multilingual_v2";
export const ELEVENLABS_OUTPUT_FORMAT = "mp3_44100_128";
export const ELEVENLABS_BASE_URL = "https://api.elevenlabs.io";
export const ELEVENLABS_OPTIMIZE_LATENCY = 2;
